export default "__VITE_ASSET__BdCkYaLA__"